import React, { useState } from 'react';
import Layout from './components/Layout';
import Header from './components/Header';
import Input from '../../components/common/Input';
import { Playground, Control } from './components/Playground';
import styles from './Input.module.css';

const InputPlayground = () => {
  const [inputConfig, setInputConfig] = useState({
    label: '레이블',
    placeholder: '플레이스홀더',
    description: '',
    error: '',
    disabled: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setInputConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <Playground
      controls={
        <>
          <Control
            label="레이블"
            name="label"
            value={inputConfig.label}
            onChange={handleChange}
          />
          <Control
            label="플레이스홀더"
            name="placeholder"
            value={inputConfig.placeholder}
            onChange={handleChange}
          />
          <Control
            label="설명"
            name="description"
            value={inputConfig.description}
            onChange={handleChange}
          />
          <Control
            label="에러 메시지"
            name="error"
            value={inputConfig.error}
            onChange={handleChange}
          />
          <Control
            label="비활성화"
            name="disabled"
            type="checkbox"
            checked={inputConfig.disabled}
            onChange={handleChange}
          />
        </>
      }
      preview={
        <Input
          label={inputConfig.label || undefined}
          placeholder={inputConfig.placeholder}
          description={inputConfig.description || undefined}
          error={inputConfig.error || undefined}
          disabled={inputConfig.disabled}
        />
      }
    />
  );
};

const InputDemo = () => {
  const [focusedInput, setFocusedInput] = useState('');

  return (
    <Layout>
      <div className={styles.container}>
        <Header 
          title="입력"
          description="사용자로부터 데이터를 입력받는 기본적인 입력 컴포넌트입니다."
        />

        <InputPlayground />

        <section className={styles.demoSection}>
          <h2>상태</h2>
          <div className={styles.inputGrid}>
            <div className={styles.inputWrapper}>
              <h3>Enabled</h3>
              <Input
                placeholder="Enabled state"
              />
            </div>

            <div className={styles.inputWrapper}>
              <h3>Focused</h3>
              <Input
                placeholder="Click to focus"
                onFocus={() => setFocusedInput('focus')}
                onBlur={() => setFocusedInput('')}
                autoFocus={focusedInput === 'focus'}
              />
            </div>

            <div className={styles.inputWrapper}>
              <h3>Disabled</h3>
              <Input
                placeholder="Disabled state"
                disabled
              />
            </div>

            <div className={styles.inputWrapper}>
              <h3>Error</h3>
              <Input
                placeholder="Error state"
                error="에러 메시지를 표시합니다"
              />
            </div>
          </div>
        </section>

        <section className={styles.demoSection}>
          <h2>레이블과 설명</h2>
          <div className={styles.inputGrid}>
            <div className={styles.inputWrapper}>
              <h3>기본</h3>
              <Input
                placeholder="기본 입력"
              />
            </div>

            <div className={styles.inputWrapper}>
              <h3>레이블</h3>
              <Input
                label="레이블"
                placeholder="레이블이 있는 입력"
              />
            </div>

            <div className={styles.inputWrapper}>
              <h3>설명</h3>
              <Input
                label="이메일"
                placeholder="이메일 입력"
                description="회사 이메일을 입력해주세요"
              />
            </div>

            <div className={styles.inputWrapper}>
              <h3>에러 메시지</h3>
              <Input
                label="비밀번호"
                type="password"
                placeholder="비밀번호 입력"
                error="8자 이상 입력해주세요"
              />
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default InputDemo; 